unit Web.Response.Utils;

interface

function BuildServerResponseMessage(AAllSuccess: Boolean;
  const AStatusLines: array of string): string;

implementation

uses
  System.SysUtils,
  System.Classes;

function BuildServerResponseMessage(AAllSuccess: Boolean;
  const AStatusLines: array of string): string;
var
  slMessages: TStringList;
  iIdx: Integer;

begin
  slMessages := TStringList.Create;
  try
    slMessages.Delimiter := #13;
    slMessages.StrictDelimiter := True;
    slMessages.Add('');
    slMessages.Add('');

    for iIdx := Low(AStatusLines) to High(AStatusLines) do
      slMessages.Add(AStatusLines[iIdx]);

    if AAllSuccess then
      slMessages.Insert(0, 'SUCCESS')
    else
      slMessages.Insert(0, 'ERROR');

    Result := slMessages.DelimitedText;

  finally
    slMessages.Free;

  end;

end;

end.
